import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface DashboardState {
    data: Record<string, unknown>;
    loading: boolean;
    error: string | null;
    projectDashboard: Record<string, unknown>;
    projectDashboardLoading: boolean;
    projectDashboardError: string | null;
    roadmapDashboard: Record<string, unknown>;
    roadmapDashboardLoading: boolean;
    roadmapDashboardError: string | null;
    roadmapGroupDashboard: Record<string, unknown>;
    roadmapGroupDashboardLoading: boolean;
    roadmapGroupDashboardError: string | null;
    refreshStatus: Record<string, unknown>;
    refreshStatusLoading: boolean;
    refreshStatusError: string | null;
}

const initialState: DashboardState = {
    // Organization dashboard
    data: {},
    loading: false,
    error: null,

    // Project dashboard
    projectDashboard: {},
    projectDashboardLoading: false,
    projectDashboardError: null,

    // Roadmap dashboard
    roadmapDashboard: {},
    roadmapDashboardLoading: false,
    roadmapDashboardError: null,

    // Roadmap group dashboard
    roadmapGroupDashboard: {},
    roadmapGroupDashboardLoading: false,
    roadmapGroupDashboardError: null,

    // Refresh status
    refreshStatus: {},
    refreshStatusLoading: false,
    refreshStatusError: null,
};

export const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        // Organization dashboard
        setDashboardData: (state, action: PayloadAction<Record<string, unknown>>) => {
            state.data = action.payload;
        },
        setDashboardLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setDashboardError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },

        // Project dashboard
        setProjectDashboardData: (state, action: PayloadAction<Record<string, unknown>>) => {
            state.projectDashboard = action.payload;
        },
        setProjectDashboardLoading: (state, action: PayloadAction<boolean>) => {
            state.projectDashboardLoading = action.payload;
        },
        setProjectDashboardError: (state, action: PayloadAction<string | null>) => {
            state.projectDashboardError = action.payload;
        },

        // Roadmap dashboard
        setRoadmapDashboardData: (state, action: PayloadAction<Record<string, unknown>>) => {
            state.roadmapDashboard = action.payload;
        },
        setRoadmapDashboardLoading: (state, action: PayloadAction<boolean>) => {
            state.roadmapDashboardLoading = action.payload;
        },
        setRoadmapDashboardError: (state, action: PayloadAction<string | null>) => {
            state.roadmapDashboardError = action.payload;
        },

        // Roadmap group dashboard
        setRoadmapGroupDashboardData: (state, action: PayloadAction<Record<string, unknown>>) => {
            state.roadmapGroupDashboard = action.payload;
        },
        setRoadmapGroupDashboardLoading: (state, action: PayloadAction<boolean>) => {
            state.roadmapGroupDashboardLoading = action.payload;
        },
        setRoadmapGroupDashboardError: (state, action: PayloadAction<string | null>) => {
            state.roadmapGroupDashboardError = action.payload;
        },

        // Refresh status
        setRefreshStatus: (state, action: PayloadAction<Record<string, unknown>>) => {
            state.refreshStatus = action.payload;
        },
        setRefreshStatusLoading: (state, action: PayloadAction<boolean>) => {
            state.refreshStatusLoading = action.payload;
        },
        setRefreshStatusError: (state, action: PayloadAction<string | null>) => {
            state.refreshStatusError = action.payload;
        },
    }
});

export const {
    setDashboardData,
    setDashboardLoading,
    setDashboardError,
    setProjectDashboardData,
    setProjectDashboardLoading,
    setProjectDashboardError,
    setRoadmapDashboardData,
    setRoadmapDashboardLoading,
    setRoadmapDashboardError,
    setRoadmapGroupDashboardData,
    setRoadmapGroupDashboardLoading,
    setRoadmapGroupDashboardError,
    setRefreshStatus,
    setRefreshStatusLoading,
    setRefreshStatusError,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
